

import {defineComponent, PropType} from "vue";
import {StepItem} from "../dto/StepItem";

export default defineComponent({
    name: "ProgressBar",
    props: {
        steps: {
            type: Array as PropType<StepItem[]>,
            required: true
        },
        currentStep: {
            type: Number,
            required: true
        },
        currentSubStep: {
            type: Number,
            default: 1
        }
    },
    computed: {
        mobileCurrentSubStep() {
            let currentSubStep = 0;
            for (let i = 0;  i < this.currentStep; i++) {
                let step = this.steps[i];
                if (!step.disabled) {
                    if (i < this.currentStep - 1) {
                        currentSubStep += this.subStepsCount(step);
                    } else {
                        currentSubStep += this.currentSubStep - 1;
                        }
                    }
            }
            return currentSubStep;
        },
        mobileCurrentActiveStep() {
            let currentStep = 0;
            for (let i = 0;  i < this.currentStep; i++) {
                let step = this.steps[i];
                if (!step.disabled) {
                    currentStep += 1;
                }
            }
            return currentStep;
        },
        totalSteps() {
            let total = 0;
            this.steps.forEach((step: StepItem) => {
                if (!step.disabled) {
                    total += 1;
                }
            });
            return total;
        },
        totalSubSteps() {
            let total = 0;
            this.steps.forEach((step: StepItem) => {
                if (!step.disabled) {
                total += this.subStepsCount(step);
                }
            });
            return total;
        }
    },
    mounted() {
        //@ts-ignore
        ob1.Ob1Component.load(document.body);
    },
    methods: {
        clickOnBackButton() {
            let step = 1;
            let subStep = 1;
            if (this.currentSubStep > 1) {
                step = this.currentStep;
                subStep = this.currentSubStep - 1;
            } else if (this.currentStep > 1 && this.currentSubStep === 1) {
                step = this.currentStep - 1;
                subStep = this.steps[step - 1].subStepsCount;
            }
            this.$emit('click', step, subStep);
        },
        clickOnStep(selectedStepNumber: number) {
            this.$emit('click', selectedStepNumber);
        },
        desktopLabel(index: number) {
            return this.steps[index].label;
        },
        mobileLabel() {
            let label = this.mobileCurrentActiveStep + "/" + this.totalSteps + " : ";
            return this.finalMobileLabel(label);
        },
        accessibilityMobileLabel() {
            let label = this.mobileCurrentActiveStep + " sur " + this.totalSteps + " : ";
            return this.finalMobileLabel(label);
        },
        finalMobileLabel(label: string) {
            return "Étape " + label + this.steps[this.currentStep - 1].label;
        },
        subStepsCount(step: StepItem) {
            let subStepsCount = step.subStepsCount;
            if (subStepsCount) {
                return subStepsCount;
            } else {
                return 1; // valeur par défaut, si indéfini (on considère qu'il n'y a qu'une sous-étape)
            }
        },
        subStepIndex(step: StepItem, index: number) {
            if (index < this.currentStep - 1 && !step.disabled) {
                return this.subStepsCount(step); // étape terminée
            }
            if (index === this.currentStep - 1) {
                return this.currentSubStep - 1; // étape active
            }
            if (index > this.currentStep - 1 || step.disabled) {
                return 0; // étape non démarrée
            }
        }
    }
})

